<template>
  <q-card class="full-width" style="max-width: 500px">
    <q-card-section>
      <div class="text-h6">{{ textHeader }}</div>
      <div class="row justify-between">
        <div class="col">
          <q-input
            v-if="mode === `SEARCH`"
            dense
            rounded
            outlined
            v-model="searchCustomer.keyword"
            placeholder="Search customer"
            style="max-width: 500px; margin-top: 10px"
            ><template v-slot:prepend>
              <q-icon name="person_search" color="gray-10" /></template
          ></q-input>
        </div>
      </div>
    </q-card-section>
    <q-card-section style="height: 40vh" class="scroll">
      <div v-if="mode === `SEARCH`" class="search-customer">
        <div v-if="filteredCustomerList.length > 0">
          <q-list bordered separator>
            <q-item
              clickable
              @click="onSelectCustomer(customer)"
              v-for="(customer, index) in filteredCustomerList"
              :key="index"
            >
              <q-item-section>
                <q-item-label
                  >{{ customer.firstname }}
                  {{ customer.lastname }}</q-item-label
                >
                <q-item-label caption>{{ customer.email }}</q-item-label>
                <q-item-label caption>{{ customer.phone_number }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
        <q-btn
          @click="onAddCustomerWithForm"
          v-close-popup
          v-else
          flat
          color="primary"
          icon="person_add"
        >
          Add new customer</q-btn
        >
      </div>
      <!-- <q-form v-if="mode === `ADD`">
        <q-input
          label="Customer name"
          v-model="addCustomerDialog.form.name"
          :rules="[
            (val) =>
              (val !== null && val !== '') || 'Please type customer name',
          ]"
          autofocus
        />
        <q-input
          label="Email address"
          v-model="addCustomerDialog.form.email"
          :rules="[
            (val) =>
              (val !== null && val !== '') || 'Please type customer email',
          ]"
        />
        <q-input
          label="Phone number"
          v-model="addCustomerDialog.form.phone"
          :rules="[
            (val) =>
              (val !== null && val !== '') ||
              'Please type customer phone number',
          ]"
        />
        <q-input
          label="Shipping address"
          v-model="addCustomerDialog.form.address"
          :rules="[
            (val) =>
              (val !== null && val !== '') || 'Please type customer address',
          ]"
        />
      </q-form> -->
    </q-card-section>
    <!-- <q-card-actions v-if="mode === `ADD`" align="right" class="text-primary">
      <q-btn flat no-caps label="Cancel" v-close-popup />
      <q-btn flat no-caps @click="onAddCustomerSubmit" label="Add customer" />
    </q-card-actions> -->
    <q-card-actions v-if="mode === `SEARCH`" align="right" class="text-primary">
      <q-btn
        flat
        no-caps
        label="Load more"
        @click="onLoadMore"
        :disable="!nextToken"
        :loading="loadMoreLoading"
      />
      <q-btn flat no-caps label="Close" v-close-popup />
    </q-card-actions>
    <q-dialog
      v-model="confirmDialog"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <DialogAlert
        message="Do you want to add this customer?"
        left-btn="Cancel"
        right-btn="Confirm"
        @leftClick="onleftClickDialog"
        @rightClick="onrightClickDialog"
      />
    </q-dialog>
  </q-card>
</template>

<script>
// import {
//   QDialog,
//   QBtn,
//   QCardSection,
//   QCardActions,
//   QItem,
//   QItemSection,
//   QItemLabel,
//   QList,
// } from "quasar";

// const components = {
//   QDialog,
//   QBtn,
//   QCardSection,
//   QCardActions,
//   QItem,
//   QItemSection,
//   QItemLabel,
//   QList,
// };
import useLoadSaleData from "@/mixins/useLoadSaleData";

export default {
  name: "AddCustomerDialog",
  components: {
    // ...components,
    DialogAlert: () => import("@/ui/components/DialogAlert.vue"),
  },
  mixins: [useLoadSaleData],
  data() {
    return {
      mode: "SEARCH",
      confirmDialog: false,
      selectedCustomer: null,
      addCustomerDialog: {
        show: false,
        form: {
          name: null,
          email: null,
          address: null,
          phone: null,
        },
      },
      searchCustomer: {
        keyword: null,
      },
      filteredCustomerList: [],
      nextToken: null,
      loadMoreLoading: false,
    };
  },
  computed: {
    textHeader() {
      if (this.mode === "SEARCH") {
        return "Search customer";
      }
      return "Add new customer";
    },
  },
  mounted() {
    // this.$services.customers.searchByPhone("082").then((val) => {
    //   console.log(val)
    // })
  },
  watch: {
    "searchCustomer.keyword": {
      immediate: false,
      handler(keyword) {
        console.log("watch: searchCustomer.keyword");
        if (keyword) {
          if (isNaN(keyword)) {
            //keyword is not a number check name or email
            if (keyword.search("@") >= 0) {
              console.log("search by email");
              this.$services.customers
                .searchByEmail(keyword)
                .then((result) => {
                  console.log("result: ", result);
                  this.filteredCustomerList = result.customers;
                  this.nextToken = result.nextToken;
                })
                .catch((e) => {
                  console.log(e);
                });
            } else {
              console.log("search by name");
              this.$services.customers
                .searchByName(keyword)
                .then((result) => {
                  console.log("result: ", result);
                  this.filteredCustomerList = result.customers;
                  this.nextToken = result.nextToken;
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          } else {
            //keyword is a number searh with phone number
            console.log("search by phone");
            this.$services.customers
              .searchByPhone(keyword)
              .then((result) => {
                console.log("result: ", result);
                this.filteredCustomerList = result.customers;
                this.nextToken = result.nextToken;
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          this.filteredCustomerList = [];
          this.nextToken = null;
        }
      },
    },
  },
  methods: {
    onAddCustomerSubmit() {
      this.$emit("addCustomerWithForm", this.addCustomerDialog.form);
    },
    onSelectCustomer(customer) {
      this.selectedCustomer = customer;
      this.confirmDialog = true;
    },
    getDialogMessage() {
      return `Do you want to add ${this.selectedCustomer.name} to your customer list.`;
    },
    onleftClickDialog() {
      this.confirmDialog = false;
    },
    async onrightClickDialog() {
      try {
        console.log("confirmAddCustomer", this.selectedCustomer);
        this.confirmDialog = false;
        await this.$store.dispatch("sale/addExistingCustomer", {
          customerID: this.selectedCustomer.id,
        });
        console.log("load sale data");
        this.loadSaleData(true);
        this.$emit("confirmAddCustomer", this.selectedCustomer);
      } catch (error) {
        console.warn(error);
        this.$q
          .dialog({
            title: "Error",
            message: error.message,
          })
          .onOk(() => {
            // console.log('OK')
          })
          .onCancel(() => {
            // console.log('Cancel')
          })
          .onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          });
      }
    },
    onAddCustomerWithForm() {
      this.$router.push({
        name: "CreateCustomer",
      });
    },
    onLoadMore() {
      console.log("load more customer");
      this.loadMoreLoading = true;
      if (this.searchCustomer.keyword) {
        if (isNaN(this.searchCustomer.keyword)) {
          //keyword is not a number check name or email
          if (this.searchCustomer.keyword.search("@") >= 0) {
            console.log("search by email");
            this.$services.customers
              .searchByEmail(this.searchCustomer.keyword, this.nextToken)
              .then((result) => {
                console.log("result: ", result);
                this.filteredCustomerList = [
                  ...this.filteredCustomerList,
                  ...result.customers,
                ];
                this.nextToken = result.nextToken;
                this.loadMoreLoading = false;
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            console.log("search by name");
            this.$services.customers
              .searchByName(this.searchCustomer.keyword, this.nextToken)
              .then((result) => {
                console.log("result: ", result);
                this.filteredCustomerList = [
                  ...this.filteredCustomerList,
                  ...result.customers,
                ];
                this.nextToken = result.nextToken;
                this.loadMoreLoading = false;
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          //keyword is a number searh with phone number
          console.log("search by phone");
          this.$services.customers
            .searchByPhone(this.searchCustomer.keyword, this.nextToken)
            .then((result) => {
              console.log("result: ", result, this.filteredCustomerList);
              this.filteredCustomerList = [
                ...this.filteredCustomerList,
                ...result.customers,
              ];
              this.nextToken = result.nextToken;
              this.loadMoreLoading = false;
            })
            .catch((e) => {
              console.log(e);
            });
        }
      }
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  display: none;
}
</style>
